import { create } from "zustand";
import { persist } from "zustand/middleware";

const useSelectedCompanyStore = create(
  persist(
    (set) => ({
      selectedCompany: null,

      setSelectedCompany: (company) =>
        set({
          selectedCompany: company,
        }),

      clearSelectedCompany: () =>
        set({
          selectedCompany: null,
        }),
    }),
    {
      name: "selected-company",
    },
  ),
);

export default useSelectedCompanyStore;